import { type PayloadAction, createSlice } from '@reduxjs/toolkit'

interface ExpressionBuilderState {
  rawValues: Record<string, string>
}

const initialState: ExpressionBuilderState = {
  rawValues: {},
}

const expressionBuilderSlice = createSlice({
  name: 'expressionBuilder',
  initialState,
  reducers: {
    clearRawValues(state) {
      state.rawValues = {}
    },
    setRawValue(
      state,
      action: PayloadAction<{
        id: number
        value: string
      }>,
    ) {
      const { id, value } = action.payload
      state.rawValues[id] = value
    },
  },
})

export const { clearRawValues, setRawValue } = expressionBuilderSlice.actions
export default expressionBuilderSlice.reducer
